import React from "react";
import { useTranslation } from "react-i18next";
import { StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { capitalize } from "@helpers/general";

type ModalLoadingType = {
    isOpen: boolean;
    data: any;
};

export default function ModalLoading({ isOpen, data }: ModalLoadingType) {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <Modal centered isOpen={isOpen}>
                <ModalHeader
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <StyledH2>{capitalize(t(data.title))}</StyledH2>
                </ModalHeader>
                <ModalBody>
                    <div className="loader" style={{ marginLeft: "40%" }} />
                    <StyledLabel
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            textAlign: "center",
                        }}
                    >
                        {t("Please wait")}
                        <br />
                        {t(data.message)}
                    </StyledLabel>
                </ModalBody>
                <ModalFooter></ModalFooter>
            </Modal>
        </React.Fragment>
    );
}
